import React, { Component } from 'react';
import { Captcha } from 'reactjs-captcha';


export class Contact extends Component {
    static displayName = Contact.name;

    constructor(props) {
        super(props);


        this.state = {

            contactInfo: {
                name: "",
                email: "",
                phone: "",
                message: ""
            },
            closeWindow: false,
            captchaValidated: false
        };

        this.sendEmail = this.sendEmail.bind(this);

        this.checkRequired = this.checkRequired.bind(this);
    }

    checkRequired(event) {
        event.preventDefault();

        var Name = document.getElementById("name").value;
        var Email = document.getElementById("email").value;
        var Message = document.getElementById("message").value;
        var Phone = document.getElementById("phone").value;

        if (Email !== "" && Email && Message !== "" && Name !== "" && Phone !== "") {
            document.getElementById("success").innerText = "";
            document.getElementById("success").style = "display:none";
        }
    }

    sendEmail(event) {
        event.preventDefault();
        
        var contactInfo = {
            Name: document.getElementById("name").value,
            Email: document.getElementById("email").value,
            Message: document.getElementById("message").value,
            Phone: document.getElementById("phone").value
        };

        if (contactInfo.Email === "" || contactInfo.Message === "" || contactInfo.Name === "" || contactInfo.Phone === "") {
            document.getElementById("success").innerText = "Oops! Required fields are not filled in.";
            document.getElementById("success").style = "display:block";
        }
        else if (contactInfo.Email.indexOf("@") == 0) {
            document.getElementById("success").innerText = "Invalid email address detected.";
            document.getElementById("success").style = "display:block";
        }
        else {


            this.setState({ contactInfo: contactInfo, closeWindow: true });

            //Call Controller
            fetch('/api/contact/sendemail', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(contactInfo)
            })
                .then((resp) => {
                    // check resp.status == 200

                    if (resp.ok) {
                        document.getElementById("success").innerText = "Submitted.  Thank you for reaching out!";
                        document.getElementById("success").style = "display:block";
                    }
                })
        }
    }

    captchaValidation(e) {
        e.preventDefault();

        let self = this;
        // the user-entered captcha code value to be validated at the backend side
        let userEnteredCaptchaCode = self.captcha.getUserEnteredCaptchaCode();

        // the id of a captcha instance that the user tried to solve
        let captchaId = self.captcha.getCaptchaId();

        if (userEnteredCaptchaCode === "") {
            return JSON.stringify(false);
        }

        
        // post the captcha data to the /your-app-backend-path on your backend.     
        let postData = {
            userEnteredCaptchaCode: userEnteredCaptchaCode,
            captchaId: captchaId
        };

        fetch('/api/contact/captchavalidation', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(postData)
        })
            .then((resp) => {
                if (resp !== undefined && resp.ok) {
                    return resp.json();
                } else {
                    self.captcha.reloadImage();
                }
            }).then((data) => {

                if (data ===undefined || data === "false") {
                    // captcha validation failed; reload image
                    self.captcha.reloadImage();
                    // TODO: maybe display an error message, too
                } else {
                    // TODO: captcha validation succeeded; proceed with your workflow
                    this.setState({
                        captchaValidated: true
                    });
                }
            });
            
    }

    render() {

        const captchaEd = this.state.captchaValidated;

        return (
            <div className="row">
                <section className="page-section" id="contact">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h2 className="section-heading text-uppercase">Contact Us</h2>
                                <h3 className="section-subheading text-muted">Reach out and we'll respond within 24 - 48 hours.</h3>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <form id="contactForm" name="sentMessage" noValidate="noValidate">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <input className="form-control" id="name" type="text" placeholder="Your Name *" required="required" data-validation-required-message="Please enter your name." onMouseUp={(event) => this.checkRequired(event)} />
                                                <p className="help-block text-danger"></p>
                                            </div>
                                            <div className="form-group">
                                                <input className="form-control" id="email" type="email" placeholder="Your Email *" required="required" data-validation-required-message="Please enter your email address." onMouseUp={(event) => this.checkRequired(event)} />
                                                <p className="help-block text-danger"></p>
                                            </div>
                                            <div className="form-group">
                                                <input className="form-control" id="phone" type="tel" placeholder="Your Phone *" required="required" data-validation-required-message="Please enter your phone number." onMouseUp={(event) => this.checkRequired(event)} />
                                                <p className="help-block text-danger"></p>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <textarea className="form-control" id="message" placeholder="Your Message *" required="required" data-validation-required-message="Please enter a message." onMouseUp={(event) => this.checkRequired(event)}></textarea>
                                                <p className="help-block text-danger"></p>
                                            </div>
                                        </div>
                                        <div className="clearfix"></div>
                                        <div className="col-md-12 text-center">

                                            <div style={{ display: captchaEd ? 'none' : 'none' }}><Captcha captchaStyleName="contactCaptcha"
                                                ref={(captcha) => { this.captcha = captcha }} />
                                                <input id="contactCaptchaInput" type="text" onMouseOut={(e) => this.captchaValidation(e)} />
                                            </div>
                                            <button id="sendMessageButton" className="btn btn-contact btn-xl text-uppercase" type="submit" disabled={this.state.captchaValidated ? "" : ""} onClick={(event) => this.sendEmail(event)}>Send Message</button>

                                            <div className="col-md-12 text-center" id="success" style={{ display: 'none' }}></div>
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div >
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Contact.js